import React, { useState, useRef, useEffect } from "react";
import PageTitle from "../../../layouts/PageTitle";
import { Col } from 'react-bootstrap';
import { GlobalSet } from '../../global/GlobalProvider';
import { Link } from "react-router-dom";
import axios from "axios";
import { useTranslation } from 'react-i18next';

const BasicDatatable = () => {
  const [income, setIncome] = useState([]);
  const [AllInvest, totalInvest] = useState([]);
  const [totalsell, totalspon_sell] = useState([]);

  const [searchUsername, setSearchUsername] = useState('');
  const [selectedPosition, setSelectedPosition] = useState("");
  const { CurrencySymbol } = GlobalSet();
  const { t } = useTranslation();

  const sort = 100;
  const activePag = useRef(0);
  const [data, setData] = useState([]);

  useEffect(() => {
    const selectedCurrency = localStorage.getItem('selectedCurrency');
    const auth_token = localStorage.getItem('auth_token');
    const data = {
      key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
      currency: selectedCurrency,
    };

    if (auth_token !== null) {
      axios.post('/all-smart-teams', data)
        .then(response => {
          setIncome(response.data.data);
          totalInvest(response.data.total_invest);
          totalspon_sell(response.data.team_and_spon_sell);
        })
        .catch(error => {
          console.log(error);
        });
    }
  }, []);

  // Filtered income based on position and username
  const filteredIncome = income
    .filter((incomerow) =>
      selectedPosition ? incomerow.team_position === selectedPosition : true
    )
    .filter((incomerow) =>
      incomerow.username.toLowerCase().includes(searchUsername.toLowerCase())
    );

  useEffect(() => {
    setTimeout(() => {
      setData(document.querySelectorAll("#job_data tbody tr"));
    }, 100);
  }, [filteredIncome]);

  const chageData = (first, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= first && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };

  useEffect(() => {
    activePag.current === 0 && chageData(0, sort);
  });

  let paggination = Array(Math.ceil(filteredIncome.length / sort))
    .fill()
    .map((_, i) => i + 1);

  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  return (
    <div className="col-12">
      <div className="card">
        <div className="card-body">
          <Col xl="12" className="p-0">
            <div className="App">
              <div className="table-responsive card booking">
                <table
                  className="display w-100 dataTable"
                  style={{ background: '#01273f' }}
                >
                  <tbody>
                    <tr className="odd" role="row">
                      <Link to="/all-team-users">
                        <td className="text-white">All Users</td>
                      </Link>
                      <td className="text-white" onClick={() => setSelectedPosition("")}>
                        <Link className="text-white" to="/my-smart-team">Position Level</Link>
                      </td>
                      <td className="text-white" onClick={() => setSelectedPosition("a")}>
                        Position A <span style={{ color: 'gold' }}>{parseFloat(AllInvest.sumA || 0).toFixed(0)}</span>
                      </td>
                      <td className="text-white" onClick={() => setSelectedPosition("b")}>
                        Position B <span style={{ color: 'gold' }}>{parseFloat(AllInvest.sumB || 0).toFixed(0)}</span>
                      </td>
                      <td className="text-white" onClick={() => setSelectedPosition("c")}>
                        Position C <span style={{ color: 'gold' }}>{parseFloat(AllInvest.sumC || 0).toFixed(0)}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Col>

          {/* Username Search Input */}
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search by Username"
              value={searchUsername}
              onChange={(e) => setSearchUsername(e.target.value)}
            />
          </div>

          <div className="table-responsive">
            <div id="job_data" className="dataTables_wrapper">
              <table className="display w-100 dataTable" id="example5">
                <thead>
                  <tr role="row">
                    <th>SL</th>
                    <th>{t('pro_his_bet_type')}</th>
                    <th>Username</th>
                    <th>Team Position</th>
                    <th>{t('pro_his_odds_name')}</th>
                    <th>Status</th>
                    <th>Self</th>
                    <th>Team Sells</th>
                    <th>Join Date</th>
                    <th>Deta</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredIncome.map((incomerow, index) => (
                    <tr key={incomerow.id} className="odd" role="row">
                      <td>{index + 1}</td>
                      <td>{incomerow.email}</td>
                      <td>{incomerow.username}</td>
                      <td>{incomerow.team_position}</td>
                      <td>{incomerow.count_active_spons} Members</td>
                      <td>{incomerow.total_invest === 0 ? 'Inactive' : 'Active'}</td>
                      <td>${incomerow.investing_wallet}</td>
                      <td>${incomerow.team_sell}</td>
                      <td>{incomerow.created_at}</td>
                      <td>
                        <Link className="btn btn-secondary" to={`/view-team/${incomerow.id}/level-g`}>
                          Next
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Pagination Controls */}
              <div className="d-sm-flex text-center justify-content-between align-items-center mt-3 mb-md-0 mb-2">
                <div className="dataTables_info">
                  Showing {activePag.current * sort + 1} to{" "}
                  {filteredIncome.length > (activePag.current + 1) * sort
                    ? (activePag.current + 1) * sort
                    : filteredIncome.length}{" "}
                  of {filteredIncome.length} entries
                </div>
                <div className="dataTables_paginate paging_simple_numbers mb-0" id="example5_paginate">
                  <Link
                    className="paginate_button previous"
                    to="#"
                    onClick={() => activePag.current > 0 && onClick(activePag.current - 1)}
                  >
                    <i className="fa fa-angle-double-left" />
                  </Link>
                  <span>
                    {paggination.map((number, i) => (
                      <Link
                        key={i}
                        to="#"
                        className={`paginate_button ${activePag.current === i ? "current" : ""}`}
                        onClick={() => onClick(i)}
                      >
                        {number}
                      </Link>
                    ))}
                  </span>
                  <Link
                    className="paginate_button next"
                    to="#"
                    onClick={() =>
                      activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1)
                    }
                  >
                    <i className="fa fa-angle-double-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicDatatable;
